import { HotWheelsStats } from './hotwheels-stats';

export function HotWheelsStatsPage() {
  return <HotWheelsStats />;
}

export default HotWheelsStatsPage;